module.exports = __webpack_public_path__ + "static/media/carto-watermark-logo.1dd827da.svg";